import * as types from "../constants";

export function setFirstSteps(value) {
  return {
    type: types.SET_STEP_UPDATE,
    payload: value
  }
}
